import React, { useCallback } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { WarningLarge } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/hooks/index';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { setSelectedCompatibilityProduct } from '@yme/pdp-components/ProductCard';
import { COOKIE_HYPERDRIVE_SELECTED_UNIT } from '@yme/pdp-components/ProductCard/CardAccessories/constants';
import { getCommonLabels, getLanguageRootPath, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { ACCESSORIES_COMPATIBILITY_KEY } from '@yme/utils/constants';
import { IconWrapperStyled } from './styled';
export function ResetModelModal() {
    const isRightToLeft = useSelector(getRTL);
    const languageRootPath = useSelector(getLanguageRootPath);
    const { common_confirm_button: confirmButtonLabel, common_cancel_button: cancelButtonLabel } = useSelector(getCommonLabels);
    const { title, description } = useSelector(getModalData);
    const dispatch = useDispatch();
    const { isInfiniteDesktopView } = useWindowSize();
    const hideModalHandler = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    const submitModalHandler = useCallback(() => {
        localStorage.removeItem(ACCESSORIES_COMPATIBILITY_KEY);
        dispatch(setSelectedCompatibilityProduct(null));
        Cookies.remove(COOKIE_HYPERDRIVE_SELECTED_UNIT, {
            path: `${languageRootPath}/`,
        });
        hideModalHandler();
    }, [dispatch, hideModalHandler, languageRootPath]);
    const modalFooter = (React.createElement(ModalWindowFooter, { isSubmitButton: true, isCancelButton: true, isSubmitButtonFullWidth: !isInfiniteDesktopView, submitButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onHide: hideModalHandler, onSubmit: submitModalHandler }));
    return (React.createElement(StaticModalWindow, { onHide: hideModalHandler, staticModalSize: MD_MODAL, title: title, minHeight: "auto", isRightToLeft: isRightToLeft, footerComponent: modalFooter },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapperStyled, null,
                React.createElement(SVGIcon, { type: WarningLarge, size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, description)));
}
